import { TIPTAP_CAPTION_TYPE } from "./../ricos-content/consts.js";
import { captionConverter } from "./converter/caption-converter.js";
import { captionTiptapExtension } from "./tiptap/caption-tiptap-extension.js";
import { figureTiptapExtension } from "./tiptap/figure-tiptap-extension.js";
const pluginFigure = {
  type: TIPTAP_CAPTION_TYPE,
  config: {},
  pmMarkConverters: [],
  pmNodeConverters: [captionConverter],
  tiptapExtensions: [figureTiptapExtension, captionTiptapExtension]
};
export {
  pluginFigure
};
//# sourceMappingURL=editor.js.map
